"use client";

import { Info } from 'lucide-react';
import { cn } from '../lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '../primitives/tooltip';

export interface InfoTooltipProps {
  text: string;
  label?: string;
  className?: string;
}

/** A short explanation behind an info icon, on hover, focus or tap. */
export function InfoTooltip({ text, label = 'More info', className }: InfoTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className={cn(
            'inline-grid size-6 place-items-center rounded-full text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-ring',
            className
          )}
        >
          <Info className="size-4" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="start" className="w-64 font-normal">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
